module.exports = __webpack_public_path__ + "static/media/no-result-image.7a6813be.png";